import type { HomePageData } from "../services/HomeService";
export { homeInsightBadgeClass as healthInsightBadgeClass } from "./homeBlueTheme";

export type HealthInsightDailyMetric = {
  value?: number;
  label?: string;
  score?: number;
  ratio_display?: string;
};

export type HealthInsightMetricCard = {
  label: string;
  badge?: string;
  score?: number;
};

export const buildHealthInsightMetricCards = (
  hi: NonNullable<HomePageData["Health Insights"]>,
): HealthInsightMetricCard[] => [
  {
    label: "Carb-Fiber",
    badge: hi.carb_fiber_ratio_daily?.label,
    score: hi.carb_fiber_ratio_daily?.score,
  },
  {
    label: "Fat Quality",
    badge: hi.bad_fat_ratio_daily?.label,
    score: hi.bad_fat_ratio_daily?.score,
  },
  {
    label: "Sugar Load",
    badge: hi.sugar_ratio_daily?.label,
    score: hi.sugar_ratio_daily?.score,
  },
  {
    label: "Protein-Fiber",
    badge: hi.protein_fiber_ratio_daily?.label,
    score: hi.protein_fiber_ratio_daily?.score,
  },
];

export const formatHealthInsightScore = (score?: number): string | null => {
  if (score == null || !Number.isFinite(score)) return null;
  return String(Math.round(score));
};

export const hasHealthInsightScore = (score?: number): boolean =>
  score != null && Number.isFinite(score);
